import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useThemeMode } from "../ThemeMode";
import saarkaLogo from "../../assets/saarka.svg?raw";

// The public site's shared pieces: the landing page and the contact page.

export const COMPANY = {
	email: "info@saarkatech.com",
	phone: "+91 7975876739",
	phoneHref: "tel:+917975876739",
	hours: ["Monday – Friday: 9:00 AM – 6:00 PM IST", "Saturday: 10:00 AM – 2:00 PM IST"],
	address: ["3c19, 3rd cross, 6th main road,", "Srinidhi Layout, Bengaluru,", "KA, India, 560062"],
};
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(COMPANY.address.join(" "))}`;

export const Icon = ({ d, size = 20, stroke = 2 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={stroke}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		{[].concat(d).map((p) => (
			<path key={p} d={p} />
		))}
	</svg>
);

export const ICONS = {
	arrow: "M5 12h14M13 6l6 6-6 6",
	check: "M5 12.5l4.5 4.5L19 7.5",
	x: "M6 6l12 12M18 6L6 18",
	record: ["M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0", "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0-18 0"],
	replay: ["M3 12a9 9 0 1 0 3-6.7", "M3 4v5h5"],
	data: ["M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3z", "M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6", "M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"],
	layers: ["M12 3l9 5-9 5-9-5 9-5z", "M3 13l9 5 9-5", "M3 17.5l9 5 9-5"],
	clock: ["M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0-18 0", "M12 7v5l3 2"],
	live: ["M2 12h4l3-8 6 16 3-8h4"],
	shield: ["M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z", "M9 12l2 2 4-4"],
	users: ["M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M2 21v-1a6 6 0 0 1 12 0v1", "M16 3.5a4 4 0 0 1 0 7.5", "M22 21v-1a6 6 0 0 0-4-5.6"],
	chart: ["M4 20V10", "M10 20V4", "M16 20v-7", "M22 20H2"],
	api: ["M8 7l-5 5 5 5", "M16 7l5 5-5 5", "M14 4l-4 16"],
	pipeline: ["M6 3v12", "M6 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6z", "M18 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z", "M18 9a9 9 0 0 1-9 9"],
	sparkle: ["M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z", "M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16z"],
	menu: ["M4 7h16", "M4 12h16", "M4 17h16"],
	mail: ["M3 6h18v12H3z", "M3 7l9 6 9-6"],
	phone: "M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z",
	pin: ["M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z", "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0"],
	calendar: ["M3 5h18v16H3z", "M3 10h18", "M8 3v4", "M16 3v4"],
	sun: ["M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0", "M12 2v2", "M12 20v2", "M4.9 4.9l1.4 1.4", "M17.7 17.7l1.4 1.4", "M2 12h2", "M20 12h2", "M4.9 19.1l1.4-1.4", "M17.7 6.3l1.4-1.4"],
	moon: "M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z",
};

// The same mark as the app's sidebar (components/Layout.jsx) and the Login page.
export const Logo = ({ onClick }) => (
	<div className="logo" style={{ cursor: onClick ? "pointer" : undefined }} onClick={onClick}>
		<div className="logo-icon">
			<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
				<path
					d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
					stroke="white"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
		<span className="logo-wordmark">
			<span className="logo-text">Testify</span>
			<span className="logo-saarka">SAARKA's</span>
		</span>
	</div>
);

/**
 * A link to a landing-page section ("#demo"). On the landing page the browser scrolls to it;
 * elsewhere it opens the landing page, which scrolls to the hash when it mounts.
 */
export function SectionLink({ hash, className, onClick, children }) {
	const location = useLocation();
	const navigate = useNavigate();
	return (
		<a
			href={`/${hash}`}
			className={className}
			onClick={(e) => {
				onClick?.();
				if (location.pathname === "/" || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
				e.preventDefault();
				navigate(`/${hash}`);
			}}
		>
			{children}
		</a>
	);
}

export function useReveal() {
	useEffect(() => {
		const els = document.querySelectorAll(".lp [data-reveal]");
		if (!("IntersectionObserver" in window)) {
			els.forEach((el) => el.classList.add("in"));
			return;
		}
		const io = new IntersectionObserver(
			(entries) =>
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("in");
						io.unobserve(entry.target);
					}
				}),
			{ threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
		);
		els.forEach((el) => io.observe(el));
		return () => io.disconnect();
	}, []);
}

const NAV_SECTIONS = [
	["#how-it-works", "How it works"],
	["#healing", "Self-healing"],
	["#features", "Features"],
	["#faq", "FAQ"],
];

export function SiteNav() {
	const navigate = useNavigate();
	const { isAuthenticated, user } = useSelector((state) => state.auth);
	const { mode, toggleMode } = useThemeMode();
	const [avatarMenuOpen, setAvatarMenuOpen] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);
	const avatarRef = useRef(null);

	const handleCta = () => navigate(isAuthenticated ? "/dashboard" : "/login");
	const fullName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "Account";
	const avatarInitials = `${user?.firstName?.charAt(0) || ""}${user?.lastName?.charAt(0) || ""}`.toUpperCase() || "U";
	const themeLabel = mode === "dark" ? "Switch to light theme" : "Switch to dark theme";

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 8);
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	useEffect(() => {
		if (!avatarMenuOpen) return;
		const handleOutside = (e) => {
			if (avatarRef.current && !avatarRef.current.contains(e.target)) {
				setAvatarMenuOpen(false);
			}
		};
		document.addEventListener("mousedown", handleOutside);
		return () => document.removeEventListener("mousedown", handleOutside);
	}, [avatarMenuOpen]);

	return (
		<nav className={`lp-nav${scrolled ? " scrolled" : ""}`}>
			<div className="container nav-inner">
				<Logo onClick={() => navigate("/")} />
				<div className="nav-links">
					{NAV_SECTIONS.map(([hash, label]) => (
						<SectionLink key={hash} hash={hash}>
							{label}
						</SectionLink>
					))}
					<Link to="/contact">Contact</Link>
				</div>
				<div className="nav-actions">
					<button className="theme-btn" onClick={toggleMode} aria-label={themeLabel} title={themeLabel}>
						<Icon d={mode === "dark" ? ICONS.sun : ICONS.moon} size={17} />
					</button>
					{isAuthenticated ? (
						<div className="nav-avatar-wrap" ref={avatarRef}>
							<button className="nav-avatar" onClick={() => setAvatarMenuOpen((o) => !o)} title={fullName}>
								{user?.avatarUrl ? <img src={user.avatarUrl} alt="avatar" /> : avatarInitials}
							</button>
							{avatarMenuOpen && (
								<div className="nav-avatar-menu">
									<div className="nav-avatar-name">{fullName}</div>
									<button onClick={() => { setAvatarMenuOpen(false); navigate("/dashboard"); }}>Open App</button>
									<button onClick={() => { setAvatarMenuOpen(false); navigate("/settings"); }}>Settings</button>
								</div>
							)}
						</div>
					) : (
						<>
							<button className="btn-ghost nav-signin" onClick={handleCta}>
								Sign in
							</button>
							<SectionLink hash="#demo" className="btn btn-light btn-sm">
								Request a demo
							</SectionLink>
						</>
					)}
					<button className="nav-burger" onClick={() => setMenuOpen((o) => !o)} aria-label="Menu" aria-expanded={menuOpen}>
						<Icon d={menuOpen ? ICONS.x : ICONS.menu} />
					</button>
				</div>
			</div>
			{menuOpen && (
				<div className="nav-mobile">
					{NAV_SECTIONS.map(([hash, label]) => (
						<SectionLink key={hash} hash={hash} onClick={() => setMenuOpen(false)}>
							{label}
						</SectionLink>
					))}
					<Link to="/contact" onClick={() => setMenuOpen(false)}>
						Contact
					</Link>
					{!isAuthenticated && (
						<>
							<SectionLink hash="#demo" onClick={() => setMenuOpen(false)}>
								Request a demo
							</SectionLink>
							<button className="btn-ghost" onClick={handleCta}>
								Sign in
							</button>
						</>
					)}
				</div>
			)}
		</nav>
	);
}

export function SiteFooter() {
	const navigate = useNavigate();
	const { isAuthenticated } = useSelector((state) => state.auth);
	return (
		<footer className="lp-footer">
			<div className="container footer-inner">
				<div className="footer-brand">
					<Logo />
					<p>No-code test automation with AI self-healing selectors, for QA teams who want to ship faster.</p>
					<div className="footer-maker">
						<span>A product of</span>
						{/* Inlined (not <img>) so the dark theme can lighten the logo's dark-blue parts. */}
						<span className="saarka-logo" role="img" aria-label="SAARKA Tech" dangerouslySetInnerHTML={{ __html: saarkaLogo }} />
					</div>
				</div>
				<div className="footer-col">
					<h4>Product</h4>
					<SectionLink hash="#how-it-works">How it works</SectionLink>
					<SectionLink hash="#healing">Self-healing</SectionLink>
					<SectionLink hash="#features">Features</SectionLink>
				</div>
				<div className="footer-col">
					<h4>Get started</h4>
					<button onClick={() => navigate(isAuthenticated ? "/dashboard" : "/login")}>
						{isAuthenticated ? "Open App" : "Sign in"}
					</button>
					<SectionLink hash="#demo">Request a demo</SectionLink>
					<Link to="/contact">Contact us</Link>
					<a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
				</div>
			</div>
			<div className="container footer-bottom">
				<span>© {new Date().getFullYear()} Testify. All rights reserved.</span>
				<Link to="/privacy">Privacy Policy</Link>
			</div>
		</footer>
	);
}
